import { NOTIFICATION_TYPE } from '../../../constants/common'

export const NOTIFICATION_PRIORITIES = {
  [NOTIFICATION_TYPE.error]: 3,
  [NOTIFICATION_TYPE.info]: 1,
  [NOTIFICATION_TYPE.warning]: 2,
}
